export const COLORS = {
  white: '#FFFFFF',
  bgHeader: '#EAF4EC',
  green: '#2E9B4F',
  greenDark: '#148763',
  textPrimary: '#313335',
  textSecondary: '#858A91',
  textMuted: '#8A9097',
  cardBg: '#F6F6F7',
  border: '#E4E6E8',
  tableHeaderBg: '#F1F3F4',
  rowAlt: '#FBFBFC',
  badgeRed: '#FDA29B',
  badgeOrange: '#FFC38E',
  badgeYellow: '#FEDF89',
  badgeLightGreen: '#AFEBCF',
  badgeGreen: '#77EBB5',
};

export const scale = [
  'A1',
  'A2',
  'A3',
  'B1',
  'B2',
  'B3',
  'C1',
  'C2',
  'C3',
  'D1',
  'D2',
  'D3',
  'E1',
  'E2',
  'E3',
] as const;

export const RISK_LETTER_GROUPS: {
  color: string;
  items: string[];
  label: string;
}[] = [
  {color: '#77EBB5', items: ['A1', 'A2', 'A3'], label: 'ریسک خیلی پایین'},
  {color: '#AFEBCF', items: ['B1', 'B2', 'B3'], label: 'ریسک پایین'},
  {color: '#FEDF89', items: ['C1', 'C2', 'C3'], label: 'ریسک متوسط'},
  {color: '#FFC38E', items: ['D1', 'D2', 'D3'], label: 'ریسک بالا'},
  {color: '#FDA29B', items: ['E1', 'E2', 'E3'], label: 'ریسک خیلی بالا'},
];

export const SCALE_COLORS: Record<string, string> = {
  E3: COLORS.badgeRed,
  E2: COLORS.badgeRed,
  E1: COLORS.badgeRed,
  D3: COLORS.badgeOrange,
  D2: COLORS.badgeOrange,
  D1: COLORS.badgeOrange,
  C3: COLORS.badgeYellow,
  C2: COLORS.badgeYellow,
  C1: COLORS.badgeYellow,
  B3: COLORS.badgeLightGreen,
  B2: COLORS.badgeLightGreen,
  B1: COLORS.badgeLightGreen,
  A3: COLORS.badgeGreen,
  A2: COLORS.badgeGreen,
  A1: COLORS.badgeGreen,
} as const;

export const SCALE_POINTER_POSITION: Record<string, number> = {
  // starting from -31 and increasing by 15 for every step
  E3: -31,
  E2: -16,
  E1: -1,
  D3: 14,
  D2: 29,
  D1: 44,
  C3: 59,
  C2: 74,
  C1: 89,
  B3: 104,
  B2: 119,
  B1: 134,
  A3: 149,
  A2: 164,
  A1: 179,
} as const;

export const SCORE_RANGES = [
  {max: 460, degree: 0},
  {max: 520, degree: 45},
  {max: 580, degree: 90},
  {max: 640, degree: 135},
  {max: Infinity, degree: 180},
] as const;

export const CULTIVATION_STATUS: Record<string, string> = {
  tasmim_be_kesht: 'تصمیم به کشت',
  mahsul_kesht_shode: 'محصول کشت شده',
  mahsul_bardasht_shode: 'محصول برداشت شده',
  mahsul_az_bein_rafte: 'محصول از بین رفته',
};

export const PERFORMANCE_UNITS: Record<string, string> = {
  ton: 'تن',
  kilogram: 'کیلوگرم',
  gram: 'گرم',
  litre: 'لیتر',
};
